"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledAlert = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var theme = {
  basic: {
    background: '#B2DFFF',
    color: '#005999',
    border: '#005999'
  },
  success: {
    background: '#C2E8D8',
    color: '#185037',
    border: '#185037'
  },
  warning: {
    background: '#FFEA7F',
    color: '#735C0F',
    border: '#B08800'
  },
  failure: {
    background: '#F5C0BA',
    color: '#9B2012',
    border: '#9B2012'
  }
};
var getColor = function getColor(variant, prop) {
  return theme[variant][prop];
};
var StyledAlert = exports.StyledAlert = _styledComponents["default"].div(function (_ref) {
  var size = _ref.size,
    type = _ref.type;
  return "\n  display: flex;\n  flex-direction: column;\n  height: auto;\n  padding: ".concat(size === 'medium' ? '12px' : '8px', ";\n  border-radius: 5px;\n  background: ").concat(getColor(type, 'background'), ";\n  color: ").concat(getColor(type, 'color'), ";\n  font-size: ").concat(size === 'medium' ? '16px' : '14px', ";\n  line-height: ").concat(size === 'medium' ? '24px' : '16px', ";\n  border: 2px solid ").concat(getColor(type, 'border'), ";\n  box-sizing: border-box;\n  border-radius: 4px;\n\n  svg {\n    font-size: 16px;\n    margin-right: 8px;\n  }\n\n  .header {\n    display: flex;\n    align-items: center;\n    padding-bottom: ").concat(size === 'medium' ? '8px' : '0px', ";\n  }\n\n  .title {\n    font-weight: 600;\n    font-style: normal;\n    font-size: ").concat(size === 'medium' ? '16px' : '14px', ";\n    line-height: ").concat(size === 'medium' ? '24px' : '16px', ";\n    min-width: 0;\n    overflow-wrap: break-word;\n  }\n\n  .content {\n    font-weight: 400;\n    font-style: normal;\n    font-size: ").concat(size === 'medium' ? '16px' : '14px', ";\n    line-height: ").concat(size === 'medium' ? '24px' : '16px', ";\n  }\n");
});